import { render, staticRenderFns } from "./PurchaseItemsList.vue?vue&type=template&id=501251d2&"
import script from "./PurchaseItemsList.vue?vue&type=script&lang=js&"
export * from "./PurchaseItemsList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports